import { isMiax, isNasdaq, isPingCommodities } from '@ping/utils/checkCompany';

export * from './campaigns.constant';
export * from './compliance.constant';
export * from './networks.constant';
export * from './pagination-items-per-page.constant';
export * from './options.constant';

export const PORTFOLIO_PATH = isNasdaq()
  ? '/nasdaq/portfolio'
  : isMiax()
  ? '/miax/portfolio'
  : isPingCommodities()
  ? '/commodities/portfolio'
  : '/user/portfolio';
